import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import SearchFilter from 'components/_common/SearchFilter';
import PageUtil from 'utils/Page.util';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { DateType, ReceptionItemKind, getReceptionStatus, getReceptionType, ReceptionType } from 'enums/reception.enum';

const TripV = ({
    params,
    setParams,
    handleChange,
    onSearch,
    setSearch,
    onClearFilter,
    onToggleDatePickerMode,
    onHandleSearchDate,
    onOpenCreate,
    onOpenEdit,
    onChangeStatus,
    onTodaySearch,
    onChangeKPIMonth,
    onOpenTripCardEdit,
    handleExportExcel
}) => {
    const { list, isLoaded, error, search, kpiData, kpiLoaded } = params;

    const dateTypeOptions = [
        { value: DateType.RECEIVED, label: '접수일자' },
        { value: DateType.TRIP, label: '출장일자' }
    ];

    // KPI 월 변경 핸들러
    const handleKPIMonthChange = (event) => {
        const newMonth = event.target.value;
        if (onChangeKPIMonth) {
            onChangeKPIMonth(newMonth);
        }
    };

    // 완료율 계산
    const completionRate = kpiData.monthlyTripCount > 0
        ? Math.round((kpiData.completedTripCount / kpiData.monthlyTripCount) * 100)
        : 0;

    // 검색 매개변수 변경 핸들러
    const handleSearchChange = (field, value) => {
        const cur = PageUtil.deepCopy(params);
        cur.search[field] = value;
        setParams(cur);
    };

    // KPI 스켈레톤 로딩 컴포넌트
    const KPISkeleton = () => (
        <div className="mb-4">
            <div className="row g-3 mb-4">
                {[1, 2, 3].map(i => (
                    <div key={i} className="col-md-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div style={{ width: '60%' }}>
                                        <div className="placeholder-glow">
                                            <span className="placeholder col-8"></span>
                                        </div>
                                        <div className="placeholder-glow mt-2">
                                            <span className="placeholder col-6"></span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="placeholder-glow">
                                            <span className="placeholder col-12" style={{ width: '40px', height: '40px' }}></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>출장관리</span>
                        </h1>
                    </div>

                    <div className="container-fluid">
                        {/* ===== KPI 섹션 시작 ===== */}
                        {!kpiLoaded ? (
                            <KPISkeleton />
                        ) : (
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="card card-outline card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-line mr-2"></i>
                                                출장관리 현황
                                            </h3>
                                            <div className="card-tools">
                                                <div className="d-flex align-items-center">
                                                    <label className="form-label mb-0 me-2 text-muted">대상 월: {kpiData.ym}</label>
                                                    {/* <input
                                                        type="month"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '140px' }}
                                                        value={kpiData.targetMonth || new Date().toISOString().slice(0, 7)}
                                                        onChange={handleKPIMonthChange}
                                                        max={new Date().toISOString().slice(0, 7)}
                                                    /> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                {/* 월출장건수 */}
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="info-box bg-info">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-calendar-alt"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">출장건수 (월)</span>
                                                            <span className="info-box-number text-white">
                                                                {kpiData.monthlyTripCount.toLocaleString()}건
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                {kpiData.targetMonth ? `${kpiData.targetMonth.replace('-', '년 ')}월` : '이번 달'} 전체 건수
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 출장완료건수 */}
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="info-box bg-success">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-check-circle"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">출장완료건수 (월)</span>
                                                            <span className="info-box-number text-white">
                                                                {kpiData.completedTripCount.toLocaleString()}건
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div
                                                                    className="progress-bar"
                                                                    style={{
                                                                        width: `${completionRate}%`,
                                                                        backgroundColor: 'rgba(255,255,255,0.4)'
                                                                    }}
                                                                ></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                완료율: <strong>{completionRate}%</strong>
                                                                {completionRate >= 80 && (
                                                                    <span className="ms-2">
                                                                        <i className="fas fa-arrow-up text-warning"></i>
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 출장예정건수 */}
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="info-box bg-warning">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-clock"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">출장예정건수</span>
                                                            <span className="info-box-number text-white">
                                                                {kpiData.scheduledTripCount.toLocaleString()}건
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                현재 대기 중인 건수
                                                                {kpiData.scheduledTripCount > 10 && (
                                                                    <span className="ms-2">
                                                                        <i className="fas fa-exclamation-triangle"></i>
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 완료율 */}
                                                {/* <div className="col-md-3 col-sm-6">
                                                    <div className="info-box bg-danger">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-chart-pie"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">완료율</span>
                                                            <span className="info-box-number text-white">
                                                                {completionRate}%
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div
                                                                    className="progress-bar"
                                                                    style={{
                                                                        width: `${Math.max(10, completionRate)}%`,
                                                                        backgroundColor: 'rgba(255,255,255,0.4)'
                                                                    }}
                                                                ></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                {completionRate >= 90 ? '우수' :
                                                                    completionRate >= 80 ? '양호' :
                                                                        completionRate >= 70 ? '보통' : '개선필요'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>

                                            {/* 도별 출장예정건수 간단 표시 */}
                                            {kpiData.scheduledTripsByProvince && kpiData.scheduledTripsByProvince.length > 0 && (
                                                <div className="mt-3">
                                                    <h6 className="text-muted mb-2">
                                                        <i className="fas fa-map-marker-alt me-1"></i>
                                                        도별 출장예정 ({kpiData.scheduledTripsByProvince.reduce((sum, item) => sum + item.count, 0)}건)
                                                    </h6>
                                                    <div style={{ maxHeight: '120px', overflowY: 'auto' }}>
                                                        <div className="row g-2">
                                                            {kpiData.scheduledTripsByProvince.map((item, index) => (
                                                                <div key={index} className="col-xl-2 col-lg-3 col-md-4 col-6">
                                                                    <div className="card border-0 bg-light text-center py-2" style={{ minHeight: '70px' }}>
                                                                        <div className="card-body p-2">
                                                                            <h6 className="card-title text-muted mb-1" style={{ fontSize: '0.85rem' }}>
                                                                                {item.province}
                                                                            </h6>
                                                                            <h5 className="text-primary mb-0">
                                                                                {item.count}건
                                                                            </h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* ===== KPI 섹션 끝 ===== */}

                        {/* 고급 검색 필터 */}
                        <SearchFilter
                            searchParams={search}
                            onSearchChange={handleSearchChange}
                            onSearch={onSearch}
                            onClearFilter={onClearFilter}
                            todayButtonName={"출장 Today"}
                            onTodaySearch={onTodaySearch}
                            showStatusFilter={false}
                            showTypeFilter={true}
                            showDateRange={true}
                            showDateType={true}
                            dateTypeOptions={dateTypeOptions}
                            placeholder="고객명, 연락처, 출장자 등 검색"
                            onExcelDownload={handleExportExcel}
                        />

                        {/* 목록 */}
                        <div className="card card-outline card-dark">
                            <div className="card-header">
                                <div className="card-title">출장 목록</div>
                                <div className="card-tools">
                                    <span className="badge bg-secondary">
                                        {PageUtil.formatToKRW(params.total)} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: 120 }}>처리상황</th>
                                                <th>처리유형</th>
                                                <th>접수일자</th>
                                                <th>출장일자</th>
                                                <th>출장자</th>
                                                <th>연락처</th>
                                                <th>고객명</th>
                                                <th>지역</th>
                                                <th>보일러명</th>
                                                <th>제조년월</th>
                                                <th>출장내용</th>
                                                <th>주소</th>
                                                <th>출장카드</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row) => (
                                                <tr key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6' } : {}}>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={row.status || ''}
                                                            onChange={(e) => onChangeStatus(row, e.target.value)}
                                                            style={{
                                                                color: row.status === 'ARREARS' ? '#dc3545' : '',
                                                                fontWeight: row.status === 'ARREARS' ? 'bold' : '',
                                                                fontSize: row.status === 'ARREARS' ? '15px' : '',
                                                            }}
                                                        >
                                                            {params.statusSet.map((s) => (
                                                                <option key={s.value} value={s.value} style={{ textAlign: 'center' }}>
                                                                    {s.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE || row.type == ReceptionType.EXCHANGE ? ' bg-danger' : 'bg-info')}
                                                            style={{ fontSize: '15px', padding: '5px 10px' }} // 글자 크기와 여백 추가
                                                        >
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.receivedDate || ''}
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.tripCard?.tripDate || ''}
                                                    </td>
                                                    <td>
                                                        {row.tripCard?.agent || ''}
                                                    </td>
                                                    <td>
                                                        <a onClick={() => onOpenEdit(row)} style={{ cursor: 'pointer' }}>
                                                            {row.phone1 || ''}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>
                                                        {row.province || ''}
                                                    </td>
                                                    <td>
                                                        <code>{(row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.modelName || '') + (row.items?.filter(p => p.kind === ReceptionItemKind.BOILER)?.length > 1 ? ' 外' : '')}</code>
                                                    </td>
                                                    <td>
                                                        <small>{row?.items?.find(p => p.manufactureMonth)?.manufactureMonth || ''}</small>
                                                    </td>
                                                    <td>
                                                        <small className="text-info">
                                                            {row?.tripCard?.content?.length > 10
                                                                ? `${row?.tripCard?.content.substring(0, 10)}...`
                                                                : (row?.tripCard?.content || '')}
                                                        </small>
                                                    </td>
                                                    <td>{(row.address || '')}</td>
                                                    <td className="text-center">
                                                        {row.tripCard?.id &&
                                                            <button
                                                                className="btn btn-sm btn-warning"
                                                                onClick={() => onOpenTripCardEdit(row)}
                                                                title="출장카드 편집"
                                                            >
                                                                <i className="fas fa-car"></i>
                                                            </button>
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* 페이징 */}
                            {list.length > 0 && (
                                <PaginationControl
                                    page={params.search.page}
                                    total={params.total}
                                    limit={params.search.rows}
                                    changePage={(page) => {
                                        const cur = PageUtil.deepCopy(params);
                                        cur.search.page = page;
                                        setParams(cur);
                                        setSearch(true);
                                    }}
                                    ellipsis={1}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default TripV;